import { useState, useCallback } from 'react';

const STORAGE_KEY = 'normalModeQuiz_config';

const defaultConfig = {
  difficulty_id: '',
  topic_id: '',
  duration_minutes: 3,
  questions_per_song: 5
};

export const useQuizConfig = () => {
  const [config, setConfig] = useState(defaultConfig);

  const saveConfig = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    } catch (error) {
      console.warn('Failed to save quiz config to localStorage:', error);
    }
  }, [config]);

  const loadConfig = useCallback(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsedConfig = JSON.parse(saved);
        setConfig(prev => ({ ...prev, ...parsedConfig }));
      }
    } catch (error) {
      console.warn('Failed to load quiz config from localStorage:', error);
    }
  }, []);

  const clearConfig = useCallback(() => {
    setConfig(defaultConfig);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.warn('Failed to clear quiz config from localStorage:', error);
    }
  }, []);

  const updateConfig = useCallback((updates) => {
    setConfig(prev => ({ ...prev, ...updates }));
  }, []);

  return {
    config,
    setConfig,
    updateConfig,
    saveConfig,
    loadConfig,
    clearConfig
  };
};
